<template>
	<a-layout-footer>
		<p class="copyright">
			{{ $APPCFG.cfg_site_copyright }}
		</p>
	</a-layout-footer>
</template>

<script>

	export default ({
		data() {
			return {
			}
		},
	})

</script>

<style lang="scss" scoped>
    .copyright {
        padding-top: 10px;
        padding-bottom: 50px;
    }
	.nav-link svg {
		margin-right: 5px;
		vertical-align: middle;
	}
	.nav-link span {
		vertical-align: middle;
	}
	.ant-menu-submenu-popup {
		width: 100%;
	}
</style>